import React from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import Navbar from "@/components/boost/Navbar";
import Footer from "@/components/boost/Footer";
import { BRAND } from "@/constants/content";

const LegalPage = ({ title, description, children }) => (
  <div className="relative min-h-screen">
    <Helmet>
      <title>{`${title} — BoostF`}</title>
      <meta name="description" content={description} />
    </Helmet>
    <Navbar />
    <main className="pt-32 pb-24">
      <div className="container-x">
        <div className="max-w-3xl mx-auto">
          <Link to="/" className="text-sm text-emerald-700 font-mono uppercase tracking-widest">← BoostF</Link>
          <h1 className="mt-3 font-display font-extrabold tracking-tight text-slate-900" style={{ fontSize: "clamp(2rem, 4vw, 3rem)" }}>
            {title}
          </h1>
          <div className="mt-2 text-sm text-slate-500 font-mono">Last updated: {new Date().toLocaleDateString("en-IN")}</div>
          <div className="mt-8 prose prose-slate max-w-none text-slate-700 leading-relaxed [&_h2]:font-display [&_h2]:mt-8 [&_h2]:mb-3 [&_h2]:text-slate-900 [&_h2]:text-xl [&_p]:mt-3 [&_ul]:mt-3 [&_ul]:list-disc [&_ul]:pl-6 [&_li]:mt-1">
            {children}
          </div>
          <p className="mt-10 text-sm text-slate-500">
            Questions? Reach us at{" "}
            <a href={`mailto:${BRAND.supportEmail}`} className="text-emerald-700 underline">
              {BRAND.supportEmail}
            </a>.
          </p>
        </div>
      </div>
    </main>
    <Footer />
  </div>
);

export default LegalPage;
